import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { InputField, DisabledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import { DetailedSelection } from '../Common/detailedSelection';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import ConfirmActionModal from '../Common/confirmActionModal';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import EditCustomerModal from '../../containers/Sales/EditCustomerModal';
import SalesOrderAutoSuggest from '../Common/SalesOrderAutoSuggest';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import { calculateTax, calculateSavings, roundTo, roundToDecimals, normalizeFourDecimals } from '../Common/NumberUtil';
import moment from 'moment';
import checkPermission from "../Common/permissions";

import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";

// Renders Radio Filters for Search Field
const renderTypeRadios = (props) => {
  return (
    <div className="form-group" id="search-product-by">
      <label className="col-xs-3 search-by-max-width">
        <Translate value="search_by" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="ProductNum"
          checked={props.input.value === "ProductNum"}/>
        <Translate value="prod_num" />
      </label>
      <label className="col-xs-2">
        <input {...props.input} type="radio" value="RefNum"
          checked={props.input.value === "RefNum"}/>
        <Translate value="ref_num" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Name"
          checked={props.input.value === "Name"}/>
        <Translate value="name" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Description"
          checked={props.input.value === "Description"}/>
        <Translate value="description" />
      </label>
    </div>
  );
};

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class EditSalesInvoice extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,

        docDate: null,
        orderDate: null,
        confirmOpen: false,
        showEditCustomerConfirmOpen: false,
        showEditCustomerOpen: false,
        showInventoryOpen: false,
        showSIUpdatedOpen: false,
        isSICustomerUpdated: false,

        // Track order information
        totalPrice: 0,
        totalTax: 0,
        finalPrice: 0,
        totalWeight: 0,
        totalCRV: 0,
        discount: 0,
        savings: 0,

        salesInvoices: {
          rows: [],
          filters: {},
          selectedRows: [],
          editedRows: [],
          sortColumn: null,
          sortDirection: null
        },

        inventories: {
          rows: [],
        },

        editedRow: {},
        selectedInventoryRow: {},
        setWeightOpen: false,
        currentRow: null,
        rowChosen: null,
        totalLoaded: null,
        currentWeights: null,
        backLogWeights: [],
        Notation: '',
        poNum: '',
        payment: 0,
        balance: 0,
        suggestValue: '',
        salesInvoicePdfFrameLoaded: true,
        delivery: 0,

        employeeNoteDisplay: '',
        employeeNoteText: '',
        changeEmployeeNoteOpen: false,
      }

      this.addRow = this.addRow.bind(this);
      this.removeRow = this.removeRow.bind(this);
      this.updateSalesInvoice = this.updateSalesInvoice.bind(this);
      this.handleOnFocus = this.handleOnFocus.bind(this);
      this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
      this.closeShowInventory = this.closeShowInventory.bind(this);
      this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
      this.closeConfirm = this.closeConfirm.bind(this);
      this.handleAfterShowInventoryClose = this.handleAfterShowInventoryClose.bind(this);
      this.openSetWeight = this.openSetWeight.bind(this);
      this.closeSetWeight = this.closeSetWeight.bind(this);
      this.openEmployeeNote = this.openEmployeeNote.bind(this);
      this.closeEmployeeNote = this.closeEmployeeNote.bind(this);
  }

  closeSetWeight() {
    this.setState({setWeightOpen: false});
  }

  openSetWeight() {
    if (this.state.rowChosen) {
      this.props.fetchSalesOrderLineWeights(this.state.rowChosen);
    }
  }

  returnTotalWeight(totalWeight) {
    //console.log('current Row', this.state.salesInvoices.rows[this.state.currentRow])
    let salesInvoices = {...this.state.salesInvoices};
    const {
      LoadedQuantity,
      UnitPrice,
      ProductType,
    } = salesInvoices.rows[this.state.currentRow];
    salesInvoices.rows[this.state.currentRow].TotalNetWeight = +roundTo(totalWeight, 2).toFixed(2);
    if (ProductType === 'Fixed'){
      salesInvoices.rows[this.state.currentRow].TotalPrice = +roundToDecimals(LoadedQuantity * UnitPrice, 4).toFixed(4);
      //salesInvoices.rows[this.state.currentRow].TotalPrice = salesInvoices.rows[this.state.currentRow].TotalPrice.toFixed(2);
    } else {
      salesInvoices.rows[this.state.currentRow].TotalPrice = +roundToDecimals(totalWeight * UnitPrice, 4).toFixed(4);
      //salesInvoices.rows[this.state.currentRow].TotalPrice = salesInvoices.rows[this.state.currentRow].TotalPrice.toFixed(2);
    }

    let totalPrice = 0;
    salesInvoices.rows.map(row => {
      totalPrice += parseFloat(row.TotalPrice);
    });

    totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
    this.setState({ salesInvoices, totalPrice, finalPrice: (parseFloat(totalPrice) + (+roundTo(parseFloat(this.state.totalCRV), 2).toFixed(2)) + (+roundTo(parseFloat(this.state.totalTax), 2).toFixed(2))) });
  }

  openEmployeeNote() {
    this.setState({ changeEmployeeNoteOpen: true });
  }
  closeEmployeeNote() {
    this.setState({ changeEmployeeNoteOpen: false });
  }
  onChangeEmployeeNote = (e) => {
    this.setState({ employeeNoteText: e.target.value });
  }
  onSubmitEmployeeNote() {
    const { currentSalesInvoice } = this.props;
    if (!currentSalesInvoice) {
      alert("Please create invoice first before editing Employee Note");
      return;
    }
    this.props.updateInvoiceEmployeeNote(currentSalesInvoice.SalesInvoice_id, this.state.employeeNoteText).then((response) => {
      this.setState({ employeeNoteDisplay: this.state.employeeNoteText });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        alert("Patch Employee Note Failed");
      }
    });
    this.setState({ changeEmployeeNoteOpen: false });
  }

  componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      const { currentSalesInvoice } = this.props;
      console.log("this router", this.context.router);
      if (currentSalesInvoice) {
          this.props.fetchSalesInvoiceDetail(currentSalesInvoice.SalesInvoice_id);
          this.setState({
            currentCustomer: currentSalesInvoice.Deliver_Customer_id,
            Notation: currentSalesInvoice.Notation || '',
            poNum: currentSalesInvoice.PONum || '',
            payment: currentSalesInvoice.Payment !== undefined ? currentSalesInvoice.Payment : 0,
            balance: currentSalesInvoice.UnpaidAmount !== undefined ? currentSalesInvoice.UnpaidAmount : 0,
            delivery: currentSalesInvoice.Delivery || 0,
            employeeNoteDisplay: currentSalesInvoice.Note || '',
            employeeNoteText: currentSalesInvoice.Note || '',
          });
      } else {
        this.context.router.push('/salesInvoice/');
      }
      this.setAllProductQuantity(1);
      this.props.setValue('editSalesInvoice', 'searchType', 'RefNum');
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.salesInvoice && nextProps.salesInvoice != this.props.salesInvoice) {
            var salesInvoices = {...this.state.salesInvoices, rows: nextProps.salesInvoice};
            this.setState({salesInvoices});
        }

        if(nextProps.inventories && nextProps.inventories != this.props.inventories) {
            var inventoryItems = nextProps.inventories;
            var salesInvoices = {...this.state.salesInvoices};
            inventoryItems.map(item => {
              item.ItemNum = item.ProductNum;
            });

            salesInvoices.rows.map(row => {
              let index = _.findIndex(nextProps.inventories, {'Product_id': row.Product_id});
            });

            var inventories = {...this.state.inventories, rows: inventoryItems};
            this.setState({inventories});
        }

        if (nextProps.customerPrices && nextProps.customerPrices != this.props.customerPrices) {
            // let rows = JSON.parse(JSON.stringify(this.state.inventories.rows));
            let rows = [...this.state.inventories.rows];
            let customerPrices = JSON.parse(JSON.stringify(nextProps.customerPrices));

            // var mergedList = _.map(rows, customerPrices, "Product_id");
            var mergedList = _.map(rows, function (i){
              return _.merge(i, _.find(customerPrices, { Product_id: i.Product_id }));
            });

            let inventories = {...this.state.inventories, rows: mergedList };
            this.setState({ inventories });
        }

        if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
          var salesInvoices = {...this.state.salesInvoices, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines}
          let Index = 0;
          salesInvoices.rows.map(row => {
            if (row.TotalNetWeight >= 0) {
              row.Index = Index;
              Index++;
              row.NetWeight = +roundTo(parseFloat(row.NetWeight), 2).toFixed(2);
            }
          })
          let totalPrice = 0;
          let totalTax = 0;
          let finalPrice = 0;
          let totalWeight = 0;
          let totalCRV = 0;

          salesInvoices.rows.map(row => {
            totalPrice += parseFloat(row.TotalPrice);
            if (row.IsTaxable) {
              row.TotalTax = parseFloat(row.TotalPrice) * parseFloat(nextProps.salesInvoiceDetail.TaxRate / 100);
              totalTax += row.TotalTax;
            }

            totalWeight += parseFloat(row.TotalNetWeight);

            if (row.CRV)
              row.TotalCRV = +roundTo(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
            if (row.TotalCRV)
              totalCRV += row.TotalCRV;
          });
          totalTax = +roundTo(totalTax, 2).toFixed(2);
          finalPrice = parseFloat(totalPrice) + parseFloat(totalTax) + parseFloat(totalCRV);

          totalWeight = roundTo(totalWeight, 2).toFixed(2);
          totalPrice = roundToDecimals(totalPrice, 4).toFixed(4);
          finalPrice = roundTo(finalPrice, 2).toFixed(2);
          totalCRV = roundTo(totalCRV, 2).toFixed(2);
          this.setState({
            salesInvoices,
            docDate: this.props.currentSalesInvoice.CreateTime && this.props.currentSalesInvoice.CreateTime.slice(0, 10),
            orderDate: this.props.currentSalesInvoice.OrderDate && this.props.currentSalesInvoice.OrderDate.slice(0, 10),
            totalPrice, totalTax, finalPrice, totalWeight, totalCRV, taxRate: nextProps.salesInvoiceDetail.TaxRate/100,
            savings: nextProps.salesInvoiceDetail.Savings,
            discount: nextProps.salesInvoiceDetail.Discount,
          });
        }

        if (nextProps.salesOrderProduct && nextProps.salesOrderProduct !== this.props.salesOrderProduct) {
          this.selectInventoryInfo(nextProps.salesOrderProduct);
          this.props.setValue('editSalesInvoice', 'UnitPrice', roundToDecimals(nextProps.salesOrderProduct.Price, 4));
          // this.props.setSaleOrderProductValues(roundTo(nextProps.salesOrderProduct.Price, 2).toFixed(2), 'salesOrderForm', nextProps.salesOrderProduct);
          // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
        }

        if (nextProps.salesInvoicePdf && nextProps.salesInvoicePdf !== this.props.salesInvoicePdf) {
          this.setState({ salesInvoicePdfFrameLoaded: false });
        }

        if (nextProps.salesInvoiceUpdated && nextProps.salesInvoiceUpdated !== this.props.salesInvoiceUpdated) {
          this.openShowSIUpdated();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.salesInvoicePdfFrameLoaded !== this.state.salesInvoicePdfFrameLoaded && this.state.salesInvoicePdfFrameLoaded === false) {
        return false;
      }

      return true;
    }

    handleChange = (e) => {
      // let Notation = e.target.value;
      // this.setState({ Notation });
      this.setState({ [e.target.name]: e.target.value });
    }
    // breadcrumbs() {
    //   if (this.props.salesInvoiceUpdateError == null) {
    //     return <Breadcrumb>
    //       <Breadcrumb.Item>
    //         <Translate value="sales_management" />
    //       </Breadcrumb.Item>
    //       <Breadcrumb.Item>
    //         <Translate value="sales_invoice" />
    //       </Breadcrumb.Item>
    //       <Breadcrumb.Item active="true">
    //         <Translate value="edit_sales_invoice" />
    //       </Breadcrumb.Item>
    //     </Breadcrumb>
    //   } else {
    //     return <ContentWrapper><div className="alert alert-danger">{this.props.salesInvoiceUpdateError}</div></ContentWrapper>
    //   }
    // }

    getItemNumbers() {
        // var itemOptions= [];
        // this.props.inventories.map(product => {
        //     itemOptions.push({ value: product.ProductNum.ProductNum, label: product.ProductNum.ProductNum});
        // });
        // return itemOptions;

        var inventoryItemOptions = [{value: '', label: "No.       |  Name           |  Description"}];
      if (this.props.inventories) {
        this.props.inventories.map(inventoryItem => {
          let text = "                                                              ";
          let output = [inventoryItem.ProductNum.slice(0, 8), text].join('');

          output = [output.slice(0,8), '  |  ', inventoryItem.Name.slice(0,12), text].join('');
          output = [output.slice(0,26), '  |  ', inventoryItem.Description.slice(0,50), text].join('');
          output = output.slice(0,86);
          inventoryItemOptions.push({ value: inventoryItem.ProductNum, label: output})
        });
        return inventoryItemOptions;
      }
    }

    setAllProductQuantity(quantity) {
      this.props.setValue('editSalesInvoice', 'Quantity', quantity);
    }

    handleKeyPress(value, event){
      console.log('value', value);
      if(event.charCode == 13){
        if (value === 'productSearch') {
          ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
        } else {
          ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
        }
      }
    }

    handleFocusAutoSuggest() {
      const autoSuggestField = document.getElementById('sales-auto-suggest');
      autoSuggestField.focus();
      autoSuggestField.select();
    }

    updateSalesInvoice() {
      let update = {};
      update.Sales_Invoice_Lines = this.state.salesInvoices.rows;
      update.DocumentDate = new Date();
      update.TotalPrice = this.state.totalPrice;
      update.PONum = this.state.poNum;

      if (this.props.invoiceNum != null) {
        update.InvoiceNum = this.props.invoiceNum;
      }
      if (this.props.CreateTime !== null) {
        update.CreateTime = this.props.CreateTime
      }
      if (this.props.OrderDate != null) {
        update.OrderDate = this.props.OrderDate;
      }
      if (this.props.postingDate !== null) {
        update.PostingDate = this.props.postingDate;
      } else {
        alert('Posting date is required');
        return;
      }
      update.InvoiceShipDate = this.props.InvoiceShipDate;
      // for (let i = 0; i < this.state.backLogWeights.length; i++) {
      //   console.log("califo",this.state.backLogWeights);
      //   this.props.setOrderLineWeights(this.state.backLogWeights[i].currentRow, this.state.backLogWeights[i].currentWeights);
      // }
      this.props.updateSalesInvoice(update, this.props.currentSalesInvoice.SaleStatus.toLowerCase(), this.props.currentSalesInvoice.SalesInvoice_id, undefined, undefined, this.state.Notation);
    }

    checkAddRow() {
      const check = _.findIndex(this.state.salesInvoices.rows, { ProductNum: this.state.selectedInventoryRow.ProductNum });
      if (check === -1) {
        this.addRow();
      } else {
        this.setState({ case: 'addingDuplicate', confirmOpen: true });
      }
    }

    addRow() {
      if (this.state.selectedInventoryRow.Name == null) {
        return;
      }
      // const check = _.findIndex(this.state.salesInvoices.rows, {'ProductNum': this.state.selectedInventoryRow.ProductNum});
      // if (check == -1) {
      const newRows = [...this.state.salesInvoices.rows];

      const newLine = { ...this.state.selectedInventoryRow };
      newLine.Index = newRows.length;
      newLine.LoadedQuantity = this.props.Quantity;
      newLine.UnitPrice = this.props.UnitPrice;
      newLine.TotalPrice = +roundToDecimals(parseFloat(this.props.Quantity) * parseFloat(this.props.UnitPrice), 4).toFixed(4);
      newLine.TotalCRV = +roundTo(parseFloat(newLine.LoadedQuantity) * parseFloat(newLine.CRV), 2).toFixed(2);
      newLine.ItemNotation = this.props.ItemNotation;
      newLine.TotalNetWeight = this.props.Quantity * newLine.NetWeight;
      if (newLine.ProductType === 'Non-Fixed') {
        newLine.Weights = [];
        newLine.TotalNetWeight = 0;
        newLine.TotalPrice = 0;
      }
      newRows.push(newLine);

      let totalPrice = 0;
      let totalTax = 0;
      let finalPrice = 0;
      let totalWeight = 0;
      let totalCRV = 0;

      newRows.map(row => {
        totalPrice += parseFloat(row.TotalPrice);
        if (row.IsTaxable) {
          row.TotalTax = parseFloat(row.TotalPrice) * parseFloat(this.state.taxRate);
          totalTax += row.TotalTax;
        }

        if (row.TotalNetWeight != null) {
          totalWeight += parseFloat(row.TotalNetWeight);
        } else {
          totalWeight += parseFloat(row.LoadedQuantity) * parseFloat(row.NetWeight);
        }
        if (row.TotalWeight != null) {
          totalWeight = parseFloat(totalWeight) + parseFloat(row.TotalWeight);
        }
          totalWeight = +roundTo(totalWeight, 2).toFixed(2);
          totalCRV += +roundTo(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
      });
      totalTax = +roundTo(totalTax, 2).toFixed(2);
      totalCRV = +roundTo(totalCRV, 2).toFixed(2);
      finalPrice = (totalPrice + totalTax + totalCRV);

      totalWeight = +roundTo(totalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);

      const salesInvoices = { ...this.state, rows: newRows };
      this.setState({
        salesInvoices, totalPrice, totalTax, finalPrice, totalWeight, suggestValue: '', totalCRV,
      });
      // }
      this.setAllProductQuantity(1);
      this.props.resetFormInputs();
    }

    removeRow(Index) {
      let rows = [...this.state.salesInvoices.rows];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalCRV = 0;
      const discount = parseFloat(this.props.discount) || 0;
      rows = rows.filter((obj) => {
        return obj.Index !== Index;
      })

      let index = 0;
      rows.map(row => {
        if (row.IsTaxable == true) {
          totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxRate);
        }
        totalPrice = parseFloat(totalPrice) + parseFloat(row.TotalPrice);
        if (row.Weight != null)
          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalWeight);
        totalCRV += +roundTo(parseFloat(row.CRV) * parseFloat(row.LoadedQuantity), 2).toFixed(2);
        row.Index = index;
        index++;
      });
      totalTax = +roundTo(totalTax, 2).toFixed(2);
      let finalPrice = (totalPrice*(1-discount/100) + totalTax + totalCRV);
      let salesInvoices = { ...this.state.salesInvoices, rows };
      this.setState({ salesInvoices, finalPrice: +roundTo(finalPrice, 2).toFixed(2), totalPrice: +roundToDecimals(totalPrice, 4).toFixed(4), totalTax, finalWeight: +roundTo(finalWeight, 2).toFixed(2), totalCRV });
    }

    renderSaleDetail() {
      // let itemNumOptions = this.getItemNumbers();
      if (this.props.inventoriesIsLoading && !this.props.inventoriesError) return <Spinner/>
      else if (this.props.inventoriesError) return <ContentWrapper><div className="alert alert-danger">{this.props.inventoriesError}</div></ContentWrapper>
      else {
        return (
          <ContentWrapper>
            <h4><Translate value="sales_order_list" /></h4>
            <hr/>
            <Row>
              <Col xs={ 6 }>
                  <label><Translate value="document_date" /></label>
                  <Field name="DocDate" selected={new Date} component={ DisabledDatePicker }/>
              </Col>
              <Col xs={ 6 }>
                  <label><Translate value="order_date" /></label>
                  <Field name="OrderDate" component={ DatePicker }/>
              </Col>
            </Row>
            <Row>
              <Col xs={ 6 }>
                <label><Translate value="item_no" /></label>
                <Field name="NewItem" component={ DetailedSelection } options={itemNumOptions} />
                <Button className="btn btn-primary" disabled={this.props.NewItem == null} onClick={this.checkAddRow}><Translate value="add_product" /></Button>
                <Button className="btn btn-danger" disabled={this.state.salesInvoices.selectBy == 0} onClick={this.removeRow}><Translate value="remove_product" /></Button>
              </Col>
              <Col xs={ 3 }>
                <label><Translate value="quantity" /></label>
                <Field name="Quantity" ref="quantity" component={ InputField } />
              </Col>
              <Col xs={ 3 }>
                <label><Translate value="unit_price" /></label>
                <Field name="UnitPrice" component={ InputField } />
              </Col>
            </Row>
          </ContentWrapper>
        )
      }
    }

  renderSaleInvoice() {
    let that = this;
      if (this.props.detailIsLoading && !this.props.detailError) return <Spinner/>
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.detailError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.salesInvoices);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          const onRowsSelected = (rows) => {
              let newRows = this.state.salesInvoices.rows;
              rows.map (r => {
                newRows[r.rowIdx].isSelected = true;
              });
              var salesInvoices = {...this.state.salesInvoices, rows: newRows, selectedRows: this.state.salesInvoices.selectedRows.concat(rows.map(r => r.rowIdx))};
              this.setState({salesInvoices});
          }

          const onRowsDeselected = (rows) => {
              let newRows = this.state.salesInvoices.rows;
              let rowIndexes = rows.map(r => r.rowIdx);
              rows.map (r => {
                newRows[r.rowIdx].isSelected = false;
              });
              var salesInvoices = {...this.state.salesInvoices, rows: newRows, selectedRows: this.state.salesInvoices.selectedRows.filter(i => rowIndexes.indexOf(i) === -1 )};
              this.setState({salesInvoices});
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var salesInvoices = {...this.state.salesInvoices, sortColumn, sortDirection };
              this.setState({salesInvoices});
          }

          const onRowSelect = rows => {
              var salesInvoices = {...this.state.salesInvoices, selectedRows: rows};
              this.setState({salesInvoices});
          }

          //Custom Formatter component
          const IsEnabledFormatter = React.createClass({
              render() {
                if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                  else return <span className="label label-danger"><Translate value="disable" /></span>;
              }
          });

          const handleRowUpdated = e => {
              let rows = getRows();
              Object.assign(rows[e.rowIdx], e.updated);

              if(e.updated.LoadedQuantity != null) {
                if (isNaN(e.updated.LoadedQuantity)) {
                  return;
                }
                if(!rows[e.rowIdx].IsOverSaleable && (parseInt(e.updated.LoadedQuantity) > rows[e.rowIdx].InStock)) {
                  return;
                }
                if (rows[e.rowIdx].ProductType === "Fixed"){
                  Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice), 4).toFixed(4)});
                  Object.assign(rows[e.rowIdx], { TotalWeight: +roundTo(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
                  Object.assign(rows[e.rowIdx], { TotalNetWeight: +roundTo(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
                }else if (rows[e.rowIdx].ProductType === "Per-Pound"){
                  Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].UnitPrice) * parseFloat(rows[e.rowIdx].NetWeight), 4).toFixed(4)});
                  Object.assign(rows[e.rowIdx], { TotalWeight: +roundTo(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
                  Object.assign(rows[e.rowIdx], { TotalNetWeight: +roundTo(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].NetWeight), 2).toFixed(2) });
                }
                //   Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.LoadedQuantity*rows[e.rowIdx].UnitPrice*rows[e.rowIdx].NetWeight).toFixed(2)});
                if (rows[e.rowIdx].CRV > 0) {
                  Object.assign(rows[e.rowIdx], { TotalCRV: +roundTo(parseFloat(e.updated.LoadedQuantity) * parseFloat(rows[e.rowIdx].CRV), 2).toFixed(2) });
                }


                if (rows[e.rowIdx].IsTaxable)
                  Object.assign(rows[e.rowIdx], { TotalTax: parseFloat(rows[e.rowIdx].TotalPrice) * parseFloat(this.state.taxRate) });
                this.setState({ currentWeights: rows[e.rowIdx].Weights });
              }
              if(e.updated.UnitPrice != null) {
                if (rows[e.rowIdx].ProductType == "Fixed" || rows[e.rowIdx].ProductType == "Non-Product") {
                  Object.assign(rows[e.rowIdx], {TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].LoadedQuantity), 4).toFixed(4) });
                } else if (rows[e.rowIdx].ProductType === "Non-Fixed") {
                  Object.assign(rows[e.rowIdx], {TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].TotalNetWeight), 4).toFixed(4) });
                } else {
                  Object.assign(rows[e.rowIdx], {TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].LoadedQuantity), 4).toFixed(4) });
                }


                if (rows[e.rowIdx].IsTaxable)
                  Object.assign(rows[e.rowIdx], { TotalTax: parseFloat(rows[e.rowIdx].TotalPrice) * parseFloat(this.state.taxRate) });
              }

              let totalPrice = 0;
              let totalWeight = 0;
              let finalPrice = 0;
              let totalTax = 0;
              let totalCRV = 0;

              rows.map(row => {
                totalPrice += parseFloat(row.TotalPrice);
                totalWeight += parseFloat(row.NetWeight) * parseFloat(row.LoadedQuantity);
                if (row.IsTaxable) {
                  totalTax += parseFloat(row.TotalTax);
                }

                if (row.TotalCRV) {
                  totalCRV += parseFloat(row.TotalCRV);
                }
              });
              totalTax = +roundTo(totalTax, 2).toFixed(2);
              finalPrice = parseFloat(totalPrice) + parseFloat(totalTax) + parseFloat(totalCRV);

              totalWeight = +roundTo(totalWeight, 2).toFixed(2);
              totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
              finalPrice = +roundTo(finalPrice, 2).toFixed(2);
              totalCRV = +roundTo(totalCRV, 2).toFixed(2);

              let salesInvoices = { rows: rows };
              this.setState({ salesInvoices, totalPrice, totalWeight, finalPrice, totalTax, totalCRV });

              if (e.updated.LoadedQuantity != null && this.state.salesInvoices.rows[e.rowIdx].ProductType === "Non-Fixed") {
                if (!rows[e.rowIdx].Weights) {
                  rows[e.rowIdx].Weights = [];
                }
                //if (typeof (rows[e.rowIdx].Index) === 'undefined')
                rows[e.rowIdx].Index = _.findIndex(rows, {'Index': rows[e.rowIdx].Index});
                console.log("index", rows[e.rowIdx].Index);
                that.setState({ setWeightOpen: true, currentRow: e.rowIdx, rowChosen: rows[e.rowIdx].SalesOrderLine_id, totalLoaded: rows[e.rowIdx].LoadedQuantity, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx] });
              }
          }

          const IsVariableFormatter = React.createClass({
              render() {
                return <span><Button
                  bsStyle="danger"
                  className="textAlignStyle" style={{ height: '23px', width: '39px', padding: '0px' }}
                  onClick={() => {
                    // var ProductNum = this.props.dependentValues.ProductNum;
                    const Index = this.props.dependentValues.Index;
                    that.removeRow(Index);
                  }}>X</Button></span>;
                }
          });

          const IsVariableFormatter2 = React.createClass({
              render() {
                if (this.props.dependentValues.ProductType !== "Non-Fixed") {
                  return <span>{this.props.value} </span>
                } else {
                  return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
                }
              }
          });

          // Column difinition

          const columns = [
            {
                name: <Translate value="del" />,
                width: 50,
                formatter: IsVariableFormatter,
                getRowMetaData: (row) => row
            },
            {
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 70
            },
            {
                key: 'RefNum',
                name: <Translate value="ref_num" />,
                resizable: true,
                sortable: true,
                width: 80
            },
            {
                key: 'Name',
                name: <Translate value="product_name" />,
                resizable: true,
                sortable: true,
                width: 200
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 150
            },
            {
                key: 'Quantity',
                name: <Translate value="order_qty" />,
                resizable: true,
                sortable: true,
                width: 85,
            },
            {
                key: 'LoadedQuantity',
                name: <Translate value="shipped_qty" />,
                resizable: true,
                sortable: true,
                editable: true,
                width: 85,
                formatter: IsVariableFormatter2,
                getRowMetaData: (row) => row
            },
            {
                key: 'NetWeight',
                name: <Translate value="net_wt" />,
                resizable: true,
                sortable: true,
                width: 65,
                filterable: true,
            },
            {
                key: 'PackageType',
                name: <Translate value="pkg_type" />,
                resizable: true,
                sortable: true,
                width: 85
            },
            {
                key: 'UnitPrice',
                name: <Translate value="unit_dollarsign" />,
                editable: true,
                resizable: true,
                sortable: true,
                width: 75
            },
            {
              key: 'TotalPrice',
              name: <Translate value="total_dollarsign" />,
              width: 80,
              resizable: true,
              sortable: true,
            },
            {
                key: 'TotalNetWeight',
                name: <Translate value="total_wt" />,
                width: 80,
                resizable: true,
                sortable: true,
                filterable: true,
            },
            {
                key: 'ItemNotation',
                name: <Translate value="notation" />,
                editable: true,
                resizable: true,
                sortable: true,
                width: 200,
                filterable: true,
            }
          ]

          return (
            //React Table Sales Invoice
              <Row>
                <Col xs={ 12 }>
                  <div id="EditSalesInvoice-dataGrid1">
                    <ReactDataGrid
                      rowKey='Product_id'
                      enableCellSelect={true}
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      headerRowHeight={45}
                      rowGetter={rowGetter}
                      onRowSelect={onRowSelect}
                      rowsCount={getSize() }
                      minHeight={this.state.tableHeight}
                      onRowUpdated={handleRowUpdated}
                      />
                  </div>
                </Col>
              </Row>
          )
      }
  }

    checkPermission(permission) {
        return false;
    }

    // Displays the values of the inventory fields;
    selectInventoryInfo(selectedInventoryRow) {
      this.setState({
        selectedInventoryRow,
        inStock: selectedInventoryRow.InStock,
        purchased: selectedInventoryRow.Purchased,
        presale: selectedInventoryRow.PreSale,
        net_weight: selectedInventoryRow.NetWeight,
        ship_weight: selectedInventoryRow.NetWeight,
        product_type: selectedInventoryRow.ProductType });
    }

    handleOnFocus(event) {
      event.target.select();
    }

    closeConfirm() {
      // this.props.resetFormInputs();
      this.setState({ confirmOpen: false });
      // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
    }
    openShowInventory(event) {
      if(!this.props.searchValue || this.props.searchValue == "")
        return;
      switch (event.charCode) {
          case 13: // ENTER
            event.preventDefault();
            this.setState({showInventoryOpen: true});
      }
    }

    closeShowInventory(value) {
      this.handleAfterShowInventoryClose(value);
      this.setState({ showInventoryOpen: false });
    }

    openShowEditCustomerConfirm = () => {
      this.setState({ showEditCustomerConfirmOpen: true });
    }

    closeShowEditCustomerConfirm = () => {
      this.setState({ showEditCustomerConfirmOpen: false });
    }

    openShowEditCustomer = () => {
      this.setState({ showEditCustomerOpen: true });
    }

    closeShowEditCustomer = (callback) => {
      this.setState({ showEditCustomerOpen: false }, callback);
    }

    openShowSICustomerUpdated = () => {
      this.closeShowEditCustomer(() => {
        this.setState({ showSIUpdatedOpen: true, isSICustomerUpdated: true });
      });
    }

    openShowSIUpdated = () => {
      this.setState({ showSIUpdatedOpen: true });
    }

    closeShowSIUpdated = () => {
      this.setState({ showSIUpdatedOpen: false }, () => {
        const { currentSalesInvoice } = this.props;
        if (this.state.isSICustomerUpdated && currentSalesInvoice) {
          this.context.router.push({
            pathname: `/salesInvoice/${currentSalesInvoice.SalesInvoice_id}`,
            state: { prevPath: this.props.location.pathname },
          });
        }
      });
    }

    handleAfterShowInventoryClose(value) {
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }

    //Product Search Reference;
    handleKeyDown(event) {
       switch( event.keyCode ) {
           case 27:
               this.closeShowInventory('productSearch');
               break;
           default:
               break;
       }
    }

    // Renders Subtotal
    renderSubtotal() {
      let subtotal = 0;
      if (this.state.selectedInventoryRow.ProductType == "Fixed") {
        if (this.props.quantityValue) {
            subtotal = +roundTo(parseFloat(this.props.quantityValue) * parseFloat(this.props.unitPrice), 2).toFixed(2);
        }
      } else {
        if (this.props.weight) {
            subtotal = +roundTo(parseFloat(this.props.unitPrice) * parseFloat(this.props.weight) * parseFloat(this.props.quantityValue), 2).toFixed(2)
        }
      }
      if(isNaN(subtotal)) {
        subtotal = 0;
      }
      return (
        <Field  name="Subtotal" component={DisabledInputField} placeholder={subtotal}/>
      )
    }
    //End Import Chunk
    setWeights = (currentRow, currentWeights, editedRow) => {
        // let backLogWeights = [...this.state.backLogWeights];
        // let newEntry = { currentRow, currentWeights };
        // backLogWeights.push(newEntry);
        // this.setState({backLogWeights});
        let index = 0;
        let Weights = [];
        let totalWeight = 0;
        currentWeights.map(row => {
          let curWeight = parseFloat(roundTo(parseFloat(row.Weight), 2).toFixed(2));
          totalWeight += curWeight;
          Weights.push(curWeight);
        });
        const rows = [...this.state.salesInvoices.rows];
        rows[editedRow.Index].Weights = Weights;
        rows[editedRow.Index].TotalNetWeight = totalWeight;
        const salesInvoices = { ...this.state.salesInvoices, rows };
        this.setState({ salesInvoices });
    }

    keepLoaded = (oldLoaded) => {
      let salesInvoices = {...this.state.salesInvoices};
      salesInvoices.rows[this.state.currentRow].LoadedQuantity = oldLoaded;
      this.setState({ salesInvoices });
    }

    handleEditCustomerOnClick = () => {
      this.openShowEditCustomerConfirm();
    }

    handleCloseOnClick = () => {
      const { prevPath } = this.props.location.state || {};
      if (prevPath) {
        this.context.router.go(-2);
      } else {
        this.context.router.goBack();
      }
    }

    handleFocusQty = () => {
      ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).focus();
      ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).select();
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ salesInvoicePdfFrameLoaded: true });
    }

    // handleKeyPress = (value, event) => {
    //   if (event.charCode == 13) {
    //     event.preventDefault();
    //     if (value == 'unitPrice' || value == 'itemNotation') {
    //       if ((!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) && value !== 'quantity') {
    //         return;
    //       }
    //     }
    //     ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    //   }
    // }

    clearInventoryInfo = () => {
      console.log('clearing everything');
      this.setState({
        selectedInventoryRow: {},
        inStock: '',
        purchased: '',
        presale: '',
        net_weight: '',
        ship_weight: '',
        product_type: '',
      });
    }

    renderAutoSuggest() {
      return (
        <SalesOrderAutoSuggest
          CustomerNumber={this.state.currentCustomer}
          handleFocusQty={this.handleFocusQty}
          handleKeyPress={this.handleKeyPress}
          onChange={(e, { newValue }) => { this.clearInventoryInfo(); this.setState({ suggestValue: newValue }); }}
          SearchType={this.props.searchType}
          setAllProductQuantity={this.setAllProductQuantity}
          value={this.state.suggestValue}
        />
      );
    }

    renderPrint() {
      const { currentSalesInvoice } = this.props;
      return (
        <SpinnerButton
          bsStyle="primary"
          disabled={!currentSalesInvoice || !currentSalesInvoice.SalesInvoice_id || this.props.printSalesInvoiceIsLoading}
          icon="fa-print"
          translation={<Translate value="print" />}
          loading={this.props.printSalesInvoiceIsLoading}
          onClick={() => {
            this.props.printSalesInvoice(currentSalesInvoice.SalesInvoice_id);
          }}
        />
      );
    }

    renderPrintIframe() {
      const { salesInvoicePdfFrameLoaded } = this.state;
      const { salesInvoicePdf } = this.props;
      return (
        <PrintIframe
          id="salesInvoicePDF"
          loaded={salesInvoicePdfFrameLoaded}
          name="salesInvoicePDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={salesInvoicePdf}
          title={<Translate value="print_sales_invoice" />}
        />
      );
    }

    render() {
      const { savings, discount, totalCRV, totalTax, taxRate } = this.state;
      // Discount field is greater than 0 if the promo is a "percent off" type
      const promotion = (discount > 0) ? `(${discount}% Off)` : `($${savings} Off)`;
      const lines = (this.state.salesInvoices && this.state.salesInvoices.rows) ? this.state.salesInvoices.rows : [];
      const totalTaxWithPromotion = calculateTax(lines, discount, taxRate);
      const finalPriceWithPromotion = calculateSavings(discount, savings, this.state.totalPrice, totalCRV, totalTaxWithPromotion, this.state.delivery);
      const invoiceNum = (<h2><Translate value="invoice_no" /></h2>);
      const totalPrice = (<h2><Translate value="total_dollarsign" /></h2>);
      const tax = (<h2><Translate value="tax" /></h2>);
      const crv = (<h2><Translate value="crv" /></h2>);
      const finalPrice = (<h2><Translate value="final_dollarsign" /></h2>);
      const customerNote = (<h2><Translate value="customer_note" /></h2>);
      const employeeNoteTitle = (<h2><Translate value="employee_note" /></h2>);
      const modifierUserTitle = (<h2><Translate value="modifier_user" /></h2>);
      const paymentTitle = (<h2><Translate value="payment" /></h2>);
      const balanceTitle = (<h2><Translate value="balance" /></h2>);
      const deliveryTitle = (<h2><Translate value="delivery" /></h2>);
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const confirmAction = (<Translate value="confirm_action" />);
      const poNum = (<h2><Translate value="po_num" /></h2>);
      const ModalHeader = (<Translate value="your_customer_change_has_been_saved" />);
      const changeEmployeeNoteTitle = (<Translate value="change_employee_note" />);
      // Create Dialog for Skylight
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-30%',
        marginTop: '-20%',
      };
      const createDialogStyle = {
        width: '500px',
        marginLeft: '-15%',
      };
      const createDialogEditCustomerStyle = {
        width: '550px',
        marginLeft: '-15%',
      };
      const createDialogStyleWeight = {
        width: '500px',
        height: '600px',
        top: '45%',
        marginLeft: '-10%',
      };
      const createNoteDialogStyle = {
        width: '500px',
        height: '250px',
        marginLeft: '-10%'
      };

      if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
      else {
        const { salesInvoiceDetail } = this.props;
        const siNumTitle = (salesInvoiceDetail && salesInvoiceDetail.InvoiceNum) || '';
        const modifierUser = (salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name) || '';
        const saveShouldDisable = this.checkPermission("change_sales_invoice") ||
          (this.props.currentSalesInvoice && (this.props.currentSalesInvoice.SaleStatus == 'Finalized' || this.props.currentSalesInvoice.SaleStatus == 'Void')) ||
          (this.props.siCustomerIsEditing || this.props.siCustomerEdited) || this.props.salesInvoiceIsUpdating;
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            {/* Nav Trail */}
            {/* {this.breadcrumbs()} */}
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="sales_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Translate value="sales_invoice" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="edit_sales_invoice" />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar>
              {/* <Button
                bsStyle="success"
                disabled={saveShouldDisable}
                onClick={this.updateSalesInvoice}
                type="submit"
              >
                { <Glyphicon glyph="save" /><Translate value="save" /> }
                <em className="fa fa-save" /><Translate value="save" />
              </Button> */}
              <SpinnerButton
                bsStyle="success"
                disabled={saveShouldDisable}
                icon="fa-save"
                translation={<Translate value="save" />}
                loading={this.props.salesInvoiceIsUpdating}
                onClick={this.updateSalesInvoice}
              />
              <Button
                bsStyle="warning"
                disabled={!checkPermission('edit_customer_sales_invoice')}
                onClick={this.handleEditCustomerOnClick}
                type="button"
              >
                <Translate value="edit_customer" />
              </Button>
              <Button
                bsStyle="danger"
                type="reset"
                onClick={this.handleCloseOnClick} >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar>

            <Grid fluid="true" id="edit-sales-invoice">
              <Row>
                <Col xs={9}>
                  <h1><Translate value="edit_sales_invoice" />:&nbsp;{ siNumTitle }
                    {(this.props.currentSalesInvoice && this.props.currentSalesInvoice.Customer_Name)?
                     " (" + this.props.currentSalesInvoice.Customer_Name + ")" :
                     ""
                    }
                  </h1>
                </Col>
                <Col xs={3}>
                  <h2 className="pull-right"><Translate value="modifier_user" />:&nbsp;{ modifierUser }</h2>
                </Col>
              </Row>
              <Row className="row-wrapper">
                <Row>
                  {/* Search for Product */}
                  <Col xs={10} className="mb0">
                    <Panel>
                      <Row>
                        <Col xs={ 12 }>
                          <Row>
                            <Col xs={10} className="vertical-divider">
                              <Row>
                                <Col xs={ 6 }>
                                  <Field name="searchType" component={ renderTypeRadios } />
                              {this.renderAutoSuggest()}
                                </Col>
                                <Col xs={ 6 } id="product-search-outputs">
                                  <Col xs={ 2 }>
                                      <label ><Translate value="quantity" /></label>
                                      <Field name="Quantity" component={ InputField } ref="quantity" withRef={true} onFocus={this.handleOnFocus} placeholder="must be > 0" onKeyPress={(event) => {
                                            this.handleKeyPress('unitPrice', event)
                                        }}/>
                                  </Col>
                                  <Col xs={ 2 }>
                                      <label ><Translate value="unit" /><span className="dollar-sign">$$</span></label>
                                      <Field name="UnitPrice" withRef ref="unitPrice" 
                                      // normalize={normalizeFourDecimals} 
                                      component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                            this.handleKeyPress('itemNotation', event);
                                        }}/>
                                  </Col>
                                  <Col xs={ 2 }>
                                      <label><Translate value="net_wt" /></label>
                                    <Field name="Weight" component={ DisabledInputField } onFocus={this.handleOnFocus} />
                                  </Col>
                                  <Col xs={ 2 }>
                                    <Row>
                                      <Col xs={ 12 }>
                                        <label ><Translate value="subtotal" /></label>
                                      </Col>
                                        {this.renderSubtotal()}
                                    </Row>
                                  </Col>
                                  <Col xs={ 4 }>
                                    <label><Translate value="notation" /></label>
                                    <Field name="itemNotation" withRef ref="itemNotation" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                                      if (event.charCode == 13 && this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductNum) {
                                        this.handleFocusAutoSuggest();
                                        // this.clearInventoryInfo();
                                        this.checkAddRow();
                                      }
                                    }}/>
                                  </Col>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={ 1 }>
                                  <label><Translate value="inventory" />:</label>
                                </Col>
                                <Col xs={ 5 }>
                                  <Row>
                                    <Col xs={ 4 }>
                                      <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /></label>
                                      <span className="col-xs-6 inventory-highlight">{this.state.inStock}</span>
                                    </Col>
                                    <Col xs={ 4 }>
                                      <label className="col-xs-6 inlineLabel"><Translate value="purchased" /></label>
                                      <span className="col-xs-6 inventory-highlight">{this.state.purchased}</span>
                                    </Col>
                                    <Col xs={ 4 }>
                                      <label className="col-xs-6 inlineLabel"><Translate value="presale" /></label>
                                      <span className="col-xs-6 inventory-highlight">{this.state.presale}</span>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={ 6 }>
                                  <Col xs={ 4 }>
                                    <label className="col-xs-6 inlineLabel"><Translate value="net_wt" /></label>
                                    <span className="col-xs-6 inventory-highlight">{this.state.net_weight}</span>
                                  </Col>
                                  <Col xs={ 4 } style={{paddingRight: 0}}>
                                    {/*co  */}
                                    <label className="col-xs-6 inlineLabel"><Translate value="ship_wt" /></label>
                                    <span className="col-xs-6 inventory-highlight">{this.state.ship_weight}</span>
                                  </Col>
                                  <Col xs={ 4 }>
                                    <label className="col-xs-6 inlineLabel"><Translate value="total_wt" /></label>
                                    <span className="col-xs-6 inventory-highlight">{this.state.total_weight}</span>
                                  </Col>
                                </Col>
                              </Row>
                            </Col>
                            <Col xs={2}>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="created" /></label>
                                <div className="col-xs-8">
                                  <Field name="CreateTime"
                                    component={ StartOfThisMonthDatePicker}
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-4">
                                  <Translate value="posting_date" /><span className="asteriksReq" >*</span>
                                </label>
                                <div className="col-xs-8">
                                  <Field
                                    name="PostingDate"
                                    component={StartOfThisMonthDatePicker }
                                  />
                                  {/* {this.logIt()} */}
                                  {/* { () => console.log("hello", moment().startOf('month')._d) } */}
                                </div>
                              </div>
                              {
                                isTN &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ship" /></label>
                                  <div className="col-xs-8">
                                    <Field name="InvoiceShipDate"
                                      component={DatePicker}
                                    />
                                  </div>
                                </div>
                              }
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Panel>
                  </Col> {/* End Search for Product */}
                  <Col xs={2} className="position-absolute">
                    <Panel header={poNum} className="panel-po-num">
                      <div className="form-control-static">
                          <Input onChange={this.handleChange} maxLength={150} name="poNum" type="text" value={this.state.poNum} />
                      </div>
                    </Panel>
                  </Col>
                </Row>
                <Row>
                  {/* Sales Invoice Details Table */}
                  <Col xs={ 10 } className="mb0">
                    <Panel>
                      {this.renderSaleInvoice()}
                    </Panel>
                  </Col> {/* End Invoice Details Table */}

                  {/* Invoice Details Pane */}
                  <Col xs={ 2 }>
                    <Row>
                      <Col xs={12}>
                        <Panel header={invoiceNum}>
                          <div className="form-control-static edit-si-total-price-panel">
                            <div className="form-control-static" style={{ width: '100%' }} >
                              <Field
                                name="InvoiceNum"
                                component={(this.props.currentSalesInvoice != null && this.props.currentSalesInvoice.SaleStatus === 'Released') ? InputField : DisabledInputField}
                                placeholder={this.props.currentSalesInvoice && this.props.currentSalesInvoice.InvoiceNum}
                              />
                            </div>
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={12}>
                        <Panel header={totalPrice}>
                          <div className="form-control-static edit-si-total-price-panel">
                            <div>
                              <span className="dollar-sign">$</span>
                              { roundTo(this.state.totalPrice, 2) }
                            </div>
                            {
                              savings > 0 &&
                              <span className="edit-si-promotion">{ promotion }</span>
                            }
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={6}>
                        <Panel header={tax}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{totalTaxWithPromotion}
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={6}>
                        <Panel header={crv}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{this.state.totalCRV}
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={6}>
                        <Panel header={finalPrice}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{finalPriceWithPromotion}
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={6}>
                        <Panel header={deliveryTitle}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{this.state.delivery}
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={12}>
                        <Panel header={paymentTitle}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{this.state.payment}
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={12}>
                        <Panel header={balanceTitle}>
                          <div className="form-control-static">
                            <span className="dollar-sign">$</span>{this.state.balance}
                          </div>
                        </Panel>
                      </Col>
                      {/* <Col xs={12}>
                        <Panel header={modifierUserTitle} className="panel-customer-note">
                          <div className="form-control-static">
                            { modifierUser }
                          </div>
                        </Panel>
                      </Col> */}
                      <Col xs={12}>
                        <Panel header={employeeNoteTitle} className="panel-customer-note">
                          <div className="form-control-static">
                          <span onDoubleClick={() => { this.openEmployeeNote(); }}>
                            <Input maxLength={150} disabled type="text" value={this.state.employeeNoteDisplay} />
                          </span>
                          </div>
                        </Panel>
                      </Col>
                      <Col xs={12}>
                        <Panel header={customerNote} className="panel-customer-note">
                          <div className="form-control-static">
                              <Input onChange={this.handleChange} maxLength={150} name="Notation" type="text" value={this.state.Notation} />
                          </div>
                        </Panel>
                      </Col>
                    </Row>
                  </Col> {/* End Invoice Details Pane */}
                </Row>
              </Row>
            </Grid>

            <SkyLightStateless dialogStyles={createDialogStyleWeight} isVisible={this.state.setWeightOpen} onCloseClicked={() => { this.closeSetWeight(); }} title="Set Product Weights">
                <SetWeightModal invoice setWeights={this.setWeights} keepLoaded={this.keepLoaded} currentWeights={this.state.currentWeights} closeC={this.closeSetWeight} totalLoaded={this.state.totalLoaded} rowChosen={this.state.rowChosen} returnTotalWeight={this.returnTotalWeight.bind(this)} editedRow={this.state.editedRow} />
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createNoteDialogStyle} isVisible={this.state.changeEmployeeNoteOpen} onCloseClicked={() => { this.closeEmployeeNote(); }} title={changeEmployeeNoteTitle}>
              <div>
                <Row className="centerStyle">
                  <div style={{ width: '80%' }}>
                    <Input
                      type="textarea"
                      rows={5}
                      onChange={this.onChangeEmployeeNote}
                      value={this.state.employeeNoteText}
                    />
                  </div>
                </Row>
                <Row className="centerStyle">
                  <Button
                    bsStyle="success"
                    onClick={() => { this.onSubmitEmployeeNote(); }}
                  >
                    <Translate value="save" />
                  </Button>
                </Row>
              </div>
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogInventoryStyle} isVisible={this.state.showInventoryOpen} onCloseClicked={ ()=> {
                this.closeShowInventory('productSearch')}} title={selectInventoryInformation}>
                <SalesInventoryInfo
                  Customer_id={this.state.currentCustomer}
                  SearchType={this.props.searchType}
                  SearchValue={this.props.searchValue}
                  formName="editSalesInvoice"
                  closeShowInventory={this.closeShowInventory}
                  selectInventoryInfo={this.selectInventoryInfo}
                  setSaleRowValue={this.props.setSaleRowValue}
                  setAllProductQuantity={this.setAllProductQuantity}/>
            </SkyLightStateless>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
                <ConfirmActionModal
                  case={this.state.case}
                  closeC={this.closeConfirm}
                  caseAction={() => { this.addRow(); }}
                />
            </SkyLightStateless>
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.showEditCustomerConfirmOpen}
              onCloseClicked={this.closeShowEditCustomerConfirm}
              title={confirmAction}
            >
              <ConfirmActionModal
                case={<Translate value="edit_customer_confirm" />}
                caseAction={this.openShowEditCustomer}
                closeC={this.closeShowEditCustomerConfirm}
              />
            </SkyLightStateless>
            <SkyLightStateless
              dialogStyles={createDialogEditCustomerStyle}
              isVisible={this.state.showEditCustomerOpen}
              onCloseClicked={this.closeShowEditCustomer}
              title="select customer information"
            >
              <EditCustomerModal
                invoiceID={salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id}
                onCloseClicked={this.closeShowEditCustomer}
                confirmAction={this.openShowSICustomerUpdated}
              />
            </SkyLightStateless>
            <div className="remove-close-skylight">
              <SkyLightStateless
                dialogStyles={createDialogStyle}
                isVisible={this.state.showSIUpdatedOpen}
                onCloseClicked={this.closeShowSIUpdated}
                title={ModalHeader}
              >
                <br /><br />
                <Row className="centerStyle">
                  { <h4><Translate value="invoice_no" /> : {this.props.invoiceNum}</h4>}
                </Row>
                <br />
                <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" />?</h4></Row>
                <br /><br />
                <Row className="button-toolbar-center">
                  <Button bsStyle="primary" className="mr" onClick={this.closeShowSIUpdated} type="button" ><Translate value="yes" /></Button>
                  <Button bsStyle="danger" className="mr" onClick={() => {
                     this.context.router.goBack();
                     this.closeShowSIUpdated();
                     this.context.router.push('/salesInvoice/');
                   }} type="button" ><Translate value="no" /></Button>
                  { this.renderPrint() }
                </Row>
              </SkyLightStateless>
            </div>
            { this.renderPrintIframe() }
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------

        )
      }
    }
}

export default withRouter(EditSalesInvoice);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/editSalesInvoice.jsx